// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_2567026e",
      load: () => import("#nuxt-i18n/2567026e" /* webpackChunkName: "locale_en_46json_2567026e" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_da361cea",
      load: () => import("#nuxt-i18n/da361cea" /* webpackChunkName: "locale_fr_46json_da361cea" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  }
]

